import React, { useEffect } from 'react';
import { Box, Button, Divider, Skeleton, Stack, Typography } from '@mui/material';
import { getUsers, usersSelector } from '../../store/reducers';
import { UserList } from '../../components/Pages/users';
import { AddCircle, Refresh } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useTypedDispatch, useTypedSelector } from '../../hooks';

const Users: React.FC = function () {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useTypedDispatch();
  const { isLoading, users, error } = useTypedSelector(usersSelector);

  useEffect(() => {
    if (!isLoading) dispatch(getUsers());
  }, []);

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error, { variant: 'error' });
    }
  }, [error]);

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '15px',
      }}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          padding: '15px',
        }}
      >
        <Typography variant="h6" align="left">
          Users
        </Typography>

        <Box>
          <Button
            variant={'outlined'}
            style={{ marginRight: '10px' }}
            color={'primary'}
            onClick={() => dispatch(getUsers())}
          >
            <Refresh />
          </Button>
          <Button variant="outlined" startIcon={<AddCircle />} onClick={() => navigate(`/users/new`)}>
            Create User
          </Button>
        </Box>
      </Box>

      <Divider />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          flexGrow: 1,
          padding: '15px',
        }}
      >
        {isLoading ? (
          <Stack spacing={1}>
            <Skeleton animation={'pulse'} variant={'text'} width={'80vw'} height={'10vh'}>
              <UserList users={[]} />
            </Skeleton>
            <Skeleton animation={'pulse'} variant={'rectangular'} width={'80vw'} height={'65vh'}>
              <UserList users={[]} />
            </Skeleton>
          </Stack>
        ) : (
          <UserList users={users} />
        )}
      </Box>
    </Box>
  );
};

export default Users;
